import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import {
  ArrowLeft,
  Building2,
  Info,
  LockKeyhole,
  ShieldCheck,
} from "lucide-react";
import { Link as RouterLink } from "react-router-dom";

export function ResetPasswordPage() {
  return (
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          md: "minmax(380px, 1.05fr) minmax(440px, .95fr)",
        },
        bgcolor: "background.paper",
      }}
    >
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          position: "relative",
          overflow: "hidden",
          flexDirection: "column",
          justifyContent: "space-between",
          p: { md: 5, lg: 8 },
          color: "white",
          background:
            "linear-gradient(145deg, #004A99 0%, #006DCC 55%, #238FEF 100%)",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            opacity: 0.17,
            backgroundImage:
              "radial-gradient(circle at 20% 20%, white 0 2px, transparent 3px), linear-gradient(130deg, transparent 45%, white 46% 46.5%, transparent 47%)",
            backgroundSize: "42px 42px, 100% 100%",
          }}
        />
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          sx={{ position: "relative" }}
        >
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2.5,
              display: "grid",
              placeItems: "center",
              bgcolor: "var(--orbit-surface-ffffff, #FFFFFF)",
              color: "primary.main",
            }}
          >
            <Building2 />
          </Box>
          <Box>
            <Typography variant="h2" color="inherit">
              Orbit PropList
            </Typography>
            <Typography sx={{ color: "rgba(255,255,255,.75)" }}>
              Property intelligence portal
            </Typography>
          </Box>
        </Stack>
        <Box sx={{ position: "relative", maxWidth: 600 }}>
          <ShieldCheck size={36} />
          <Typography
            variant="h1"
            color="inherit"
            sx={{ mt: 3, fontSize: { md: "2.7rem", lg: "3.7rem" } }}
          >
            Secure access starts with a protected password.
          </Typography>
          <Typography
            sx={{
              mt: 2,
              fontSize: 18,
              lineHeight: 1.7,
              color: "rgba(255,255,255,.78)",
            }}
          >
            Your administrator can safely restore access to your SRMI account.
          </Typography>
        </Box>
        <Typography
          sx={{
            position: "relative",
            color: "rgba(255,255,255,.65)",
            fontSize: 13,
          }}
        >
          Orbit Property List Management System
        </Typography>
      </Box>

      <Box
        sx={{
          display: "grid",
          placeItems: "center",
          p: { xs: 2, sm: 5 },
          bgcolor: { xs: "background.default", md: "background.paper" },
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            maxWidth: 470,
            p: { xs: 3, sm: 5 },
            border: { xs: "1px solid", md: 0 },
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: 3,
              display: "grid",
              placeItems: "center",
              bgcolor: "primary.light",
              color: "primary.main",
              mb: 3,
            }}
          >
            <LockKeyhole size={36} />
          </Box>
          <Typography variant="h1" sx={{ fontSize: "2rem" }}>
            Reset password
          </Typography>
          <Typography color="text.secondary" sx={{ mt: 1, lineHeight: 1.7 }}>
            Password resets are managed by your administrator. Contact your
            system administrator to request a new password.
          </Typography>

          <Stack
            direction="row"
            spacing={1.5}
            sx={{
              mt: 4,
              p: 2,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              bgcolor: "background.default",
            }}
          >
            <Info size={20} color="#006DCC" aria-hidden="true" />
            <Typography fontSize={13} lineHeight={1.6}>
              For security, never share your current password with anyone.
            </Typography>
          </Stack>

          <Button
            component={RouterLink}
            to="/login"
            variant="contained"
            size="large"
            fullWidth
            startIcon={<ArrowLeft size={18} />}
            sx={{ mt: 4 }}
          >
            Back to sign in
          </Button>
        </Paper>
      </Box>
    </Box>
  );
}
